export default __webpack_public_path__ + "static/media/scale@2x.82301003.webp";